// safe check for duplicates in array of objects, strings, and numbers
export const removeDuplicates = (data, prop) => {
  return data.reduce((acc, item) => {
    !acc.length && acc.concat(item);
    return acc.some(each => (prop ? each[prop] : each) === (prop ? item[prop] : item))
      ? acc
      : acc.concat(item);
  }, []);
};
